import { atom } from 'recoil';

export const adminPagingAtom = atom<number>({
   key: 'adminPagingAtom',
   default: 0,
});
